import { Injectable } from '@angular/core';
import { EmbedType } from '../types/embed.type';

@Injectable({
  providedIn: 'root',
})
export class EmbedService {
  types: EmbedType[] = [
    {
      name: 'youtube',
      regex: new RegExp('(youtube.com|youtu.be)'),
    },
    {
      name: 'google maps',
      regex: new RegExp('(google..*|goo.gl)/maps/'),
    },
    {
      name: 'soundcloud',
      regex: new RegExp('soundcloud.com'),
    },
    {
      name: 'twitter',
      regex: new RegExp('twitter.com'),
    },
    {
      name: 'instagram',
      regex: new RegExp('instagram.com'),
    },
    {
      name: 'facebook',
      regex: new RegExp('facebook.'),
    },
    {
      name: 'generic',
      regex: new RegExp(
        'matterport|youriguide.com|cloudpano.com|zillow.com|zillow.com/sphere-viewer|kuula.co/share|storage.net-fs.com/hosting|my.mpskin.com|vimeo.com/showcase'
      ),
    },
    {
      name: 'vimeo',
      regex: new RegExp('vimeo.com'),
    },
  ];

  getEmbedUrl(type: EmbedType, url: URL) {
    if (!type) return;
    if (type.name === 'youtube') {
      let videoId = url.pathname.split('/').pop();
      if (videoId === 'watch') videoId = url.searchParams.get('v');
      return `https://youtube.com/embed/${videoId}`;
    }
    if (type.name === 'vimeo') {
      const videoId = url.pathname.split('/').pop();
      return `https://player.vimeo.com/video/${videoId}${url.search}`;
    }
    if (type.name === 'google maps') {
      return url.href;
    }
    if (type.name === 'soundcloud') {
      if (url.href.startsWith('https://w.soundcloud.com/player')) return url.href;
      let songName = url.pathname.split('/').pop();
      let _url = `soundcloud.com${url.pathname}`;
      if (!songName) {
        let songId = url.searchParams.get('url').split('tracks/')[0];
        _url = `api.soundcloud.com/tracks/${songId}`;
      }
      return `https://w.soundcloud.com/player/?url=https%3A//${_url}&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true`;
    }
    if (type.name === 'twitter') {
      return url.href;
    }
    if (type.name === 'instagram') {
      return (
        'https://www.instagram.com/tv/' +
        url.pathname
          .split('/')
          .filter(a => a)
          .pop()
      );
    }
    if (type.name === 'facebook') {
      if (!url.href.startsWith('https://www.facebook.com/plugins'))
        return 'https://www.facebook.com/plugins/post.php?href=' + url.href;
      return url.href;
    }
    if (type.name === 'generic') {
      return url.href;
    }
  }
}
